<template>
  <div>
    <!--      start edit mode -->
    <custom-popup
      v-model="payModal"
      :cons="{ title: ' پرداخت و ارتقا' }"
      max-width="600"
      transition="dialog-bottom-transition"
    >
      <v-card class="pa-2" flat>
        <pay-upgrade
          :modal="
            () => {
              this.payModal = false;
            }
          "
          :token="token"
        />
      </v-card>
    </custom-popup>
    <!--      end edit mode -->

    <!--      <custom-popup :cons="{title:'انتخاب شماره ها'}" reloadable max-width="900" hide-confirm v-model="chosenMode">-->
    <!--        <div class="p-10">-->
    <!--          <number-selector :multiple-numbers="true" v-if="chosenMode"></number-selector>-->
    <!--          <v-expansion-panels v-if="activeNumbers.length > 0">-->
    <!--            <v-expansion-panel>-->
    <!--              <v-expansion-panel-header>-->
    <!--                لیست شماره های فعال-->
    <!--              </v-expansion-panel-header>-->
    <!--              <v-expansion-panel-content>-->
    <!--                <v-chip close @click:close="deleteActiveNum(item.id)" @click="deleteActiveNum(item.id)" small v-for="(item,index) in activeNumbers" outlined-->
    <!--                        color="indigo" :key="index">{{ item.phone }}-->
    <!--                </v-chip>-->
    <!--              </v-expansion-panel-content>-->
    <!--            </v-expansion-panel>-->
    <!--          </v-expansion-panels>-->
    <!--          <v-btn @click="autoRenew" outlined rounded-->
    <!--                 class="btn-send-sms float-left">-->
    <!--            <v-icon>refresh</v-icon>-->
    <!--            ثبت درخواست-->
    <!--          </v-btn>-->
    <!--        </div>-->
    <!--      </custom-popup>-->

    <!--      start edit mode -->
    <custom-popup
      v-model="renewListModal"
      :cons="{ title: 'لیست تمدید گروهی' }"
      hide-confirm
      max-width="900"
      reloadable
    >
      <div class="p-10">
        <mass-renew-list v-if="renewListModal" />
      </div>
    </custom-popup>
    <!--      end edit mode -->

    <v-row no-gutters>
      <v-col class="pa-2" cols="12">
        <v-btn
          :disabled="selectedADS.length < 1"
          class="btn-delete"
          outlined
          rounded
          @click="renewAll"
        >
          <span class="fa fa-users ml-1" />
          تمدید گروهی آگهی
        </v-btn>
        <!--            <v-btn @click="chosenMode=true" outlined rounded-->
        <!--                   class="btn-send-sms float-left">-->
        <!--              <v-icon>refresh</v-icon>-->
        <!--              تمدید هوشمند آگهی-->
        <!--            </v-btn>-->

        <!--            <v-btn @click="renewListModal=true" outlined rounded-->
        <!--                   class="btn-list float-left">-->
        <!--              <v-icon>list</v-icon>-->
        <!--              لیست آگهی های اتوماتیک-->
        <!--            </v-btn>-->
      </v-col>

      <v-col class="pa-2" cols="12">
        <v-card :loading="loading" flat>
          <terminal-table
            v-if="isMobile"
            v-model="selectedADS"
            :currentPage="datas.current_page"
            :datas="datas"
            :getData="getDataForTable"
            :headers="columns"
            :options="tableProps"
            :pageCount="datas.last_page"
            :perPage="datas.per_page"
            class="col-12"
          />

          <data-table
            v-else
            :columns="columns"
            :data="datas"
            :debounce-delay="3000"
            :orderBy="tableProps.column"
            :orderDir="tableProps.dir"
            :pagination="paginate"
            :per-page="[10, 25, 50, 100, 500]"
            :translate="translate"
            class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
            @on-table-props-changed="reloadTable"
          >
            <template slot="filters" slot-scope="{ tableFilters, perPage }">
              <filters-table
                v-model="searchBox"
                @getInfo="
                  (val) => {
                    if (val) tableProps.search = searchBox.search;
                  }
                "
              >
                <template slot="others">
                  <extra-filter
                    v-model="searchBox"
                    :fields="extraFilter"
                    @getInfo="
                      (val) => {
                        if (val) reloadTable;
                      }
                    "
                  />
                </template>
              </filters-table>
            </template>
          </data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import button from "@/view/pages/button";
import { Axios2, Bus, dataTableProps } from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import createTarefe from "@/view/pages/tarefe/createTarefe";
import myChat from "@/view/pages/chats/myChatList";
import PayUpgrade from "@/view/pages/ads/adsList/payUpgrade";
import EditSimple from "@/view/pages/ads/singleAds/editSimple";
import { debounce } from "../../../../custom";
import CustomPopup from "@/core/plugins/TitleRibbon/plugins/popup/customPopup";
import MassRenewList from "@/view/pages/ads/adsList/massRenewList";
import NumberSelector from "@/view/pages/ads/numberSelector";
import FiltersTable from "@/components/Table/filtersTable";
import ExtraFilter from "@/components/Table/extraFilter";

export default {
  name: "renewAdsList",
  components: {
    ExtraFilter,
    FiltersTable,
    NumberSelector,
    MassRenewList,
    CustomPopup,
    EditSimple,
    PayUpgrade,
    TitleRibbon,
    button,
    dataTableProps,
    createTarefe,
    myChat,
  },
  props: {
    editProps: {
      type: Object,
      default: () => ({}),
    },
    UserID: {
      type: Number,
      default: () => 0,
    },
    token: {
      type: String,
      default: () => "",
    },
    editToken: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      tarafeName: "",
      deleteDialog: false,
      getConfirmCode: false,
      loading: false,
      addTelePhone: false,
      editModal: false,
      result: {},
      chatModal: false,
      adsToken: "",
      code: "",
      editAds: false,
      provider: false,
      payModal: false,
      renewListModal: false,
      chosenMode: false,
      finalReason: "",
      extraFilter: [
        {
          label: "فیلتر براساس",
          filterTitle: "provider",
          items: [
            { value: "divar", title: "آگهی های شخصی" },
            { value: "divar_shop", title: "آگهی های فروشگاهی" },
            { value: "divar_real_estate", title: "آگهی های پنل املاک" },
            { value: "divar_service", title: "آگهی های متخصص" },
          ],
        },
      ],
      datas: {},
      translate: dataTableProps.translate,
      paginate: dataTableProps.pagination,
      tableProps: dataTableProps.tableProps,
      url: `${url}/advertise/list/renew`,
      selectedADS: [],
      selectedNums: [],
      dataId: "",
      telephoneNumber: "",
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox" data-renew="${val.data.renew}" data-pay="${val.data.payment}" name="checkIt" data-id="${val.data.id}">`;
          },
          orderable: false,
        },
        {
          label: "ردیف",
          transform: (val) => {
            let row = this.datas.current_page - 1;
            row = row * this.datas.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: "شناسه",
          name: "id",
          transform(val) {
            const providers = {
              divar: "شخصی",
              sheypoor: "شیپور",
              divar_shop: "فروشگاهی",
              divar_real_estate: "املاک",
              divar_service: "‌متخصص",
            };
            const tag = `<p>${
              val.data.id
            }</p></<br><p class="badge badge-info font-weight-bold p-1">${
              providers[val.data?.provider]
            }</p>`;
            return tag;
          },
          orderable: true,
          searchable: true,
        },
        {
          label: "شماره",
          name: "number.phone",
          orderable: true,
          searchable: true,
        },
        {
          label: "موضوع",
          name: "title",
          orderable: true,
          searchable: true,
        },
        {
          label: "تاریخ ارسال",
          name: "created_at_p",
          orderable: true,
          searchable: true,
        },
        {
          label: "تاریخ حذف",
          name: "expire_at_p",
          transform: (val) => {
            if (val.data.expire_at) {
              return val.data.expire_at_p;
            } else {
              return "-";
            }
          },
          orderable: true,
        },
        {
          label: "وضعیت تمدید",
          primary: true,
          name: "payment",
          transform: (val) => {
            const color =
              val.data.payment !== null || val.data.renew !== null
                ? "success"
                : "danger";
            const icon =
              val.data.payment !== null || val.data.renew !== null
                ? "تمدید اتوماتیک"
                : "عدم تمدید";
            return `<span class="badge badge-${color}">${icon}</span>`;
          },
          orderable: true,
          searchable: true,
        },
        {
          label: "تمدید هوشمند",
          primary: true,
          name: "renew",
          transform: (val) => {
            const color =
              val.data.renew !== null && val.data.renew !== undefined
                ? "primary"
                : "danger";
            const icon =
              val.data.renew !== null && val.data.renew !== undefined
                ? "فعال"
                : "غیرفعال";
            return `<span class="badge badge-${color}">${icon}</span>`;
          },
          orderable: true,
          searchable: true,
        },
        {
          label: "مدیریت",
          name: "action",
          component: button,
          handler: this.actions,
          event: "actions",
          meta: {
            buttons: [
              {
                name: "payAndUpgrade",
                label: "پرداخت و ارتقا",
                icon: "dollar-sign",
                class: "btn-outline-success",
                action: this.actions,
                condition: this.buttonsCondition,
              },
            ],
          },
        },
      ],
      searchBox: {
        search: "",
        length: 10,
        provider: undefined,
      },
      activeNumbers: [],
    };
  },
  methods: {
    buttonsCondition(status) {
      return !status.id;
    },
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        type: "GET",
        fn: this.getDataForTable,
        data: Object.assign({}, query, {
          search: this.tableProps.search,
          length: this.searchBox.length,
          provider: this.searchBox.provider ?? undefined,
        }),
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        success: function (data) {
          vm.datas = data;
          vm.loading = false;
        },
      });
    },
    reloadTable(tableProps) {
      $("#selectAll").prop("checked", false);
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 700);
    },
    getReason(reason) {
      this.finalReason = reason;
    },
    actions(data, type) {
      if (type === "payAndUpgrade") {
        this.payModal = true;
        this.token = data.manage_token;
      }
    },
    renewAll() {
      $.ajax({
        url: `${url}/divar/advertise/mass/renew`,
        type: "POST",
        fn: this.renewAll,
        data: JSON.stringify({
          data: this.selectedADS,
        }),
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
          "Content-Type": "application/json",
        },
        msg: true,
        success: () => {
          this.selectedADS = [];
        },
      });
    },
    autoRenew() {
      if (this.selectedNums.length <= 0) {
        this.$toast.error("حداقل یک شماره انتخاب کنید.");
        return false;
      } else {
        this.$modal
          .yesNo(
            "تایید تمدید اتوماتیک گروهی",
            "از این پس ، کلیه آگهی های شماره های انتخاب شده، بصورت اتوماتیک تمدید خواهند شد.",
            "neg",
            ""
          )
          .then((value) => {
            if (value === true) {
              this.loading = true;
              Axios2.post(`/divar/number/renew/mass`, {
                numbers: this.selectedNums,
              })
                .then((response) => {
                  this.loading = false;
                  this.$toast.success("درخواست شما با موفقیت انجام شد. ");
                  this.chosenMode = false;
                  this.getDataForTable(this.url);
                })
                .catch((err) => {
                  this.loading = false;
                  console.log(err.response.data.errors);
                })
                .finally(() => {
                  this.loading = false;
                });
            } else return false;
          });
      }
    },
    activeRenewList() {
      Axios2.get(this.$robotApi + "/divar/number/has/renew").then((item) => {
        this.activeNumbers = item.data.data;
      });
    },
    deleteActiveNum(id) {
      this.$modal
        .yesNo(
          "تایید غیرفعال کردن نردبان",
          "آیا از غیرفعال کردن نردبان هوشمند این شماره اطمینان دارید؟"
        )
        .then((item) => {
          if (item)
            Axios2.delete(`${this.$robotApi}/divar/number/has/renew/${id}`)
              .then((item) => {
                this.activeNumbers = item.data.data;
              })
              .then((res) => {
                this.$toast.success("درخواست شما با موفقیت انجام شد.");
                this.activeRenewList();
                this.getDataForTable(this.url);
              })
              .catch((err) => {
                this.$toast.error("درخواست شما انجام نشد. دوباره تلاش کنید.");
              });
          else return false;
        });
    },
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          this.getDataForTable(this.url);
          return true;
        case "sm":
          this.getDataForTable(this.url);
          return true;
        case "md":
          this.getDataForTable(this.url);
          return false;
        case "lg":
          this.getDataForTable(this.url);
          return false;
        case "xl":
          this.getDataForTable(this.url);
          return false;
      }
    },
  },
  mounted() {
    this.tableProps = {
      search: "",
      length: 10,
      column: "id",
      dir: "desc",
      page: 1,
    };
    this.getDataForTable(this.url);

    this.activeRenewList();

    Bus.$on("selected_numbers", (value) => {
      this.selectedNums = value;
    });

    this.$nextTick(() => {
      $(document).unbind("click");

      $(document).on("click", "#selectAll", (element) => {
        if (!$(element.target).prop("checked") || this.selectedADS.length <= 0)
          $("input[name = 'checkIt']").each((index, item) => {
            $(item).click();
          });
      });

      $(document).on("click", `input[name = 'checkIt']`, (element) => {
        const dataPay = $(element.target).data("pay");
        const dataRenew = $(element.target).data("renew");

        if (dataPay || dataRenew) {
          $(element.target).prop("checked", false);
          return;
        }

        const selectedPart = $(element.target).data("id");

        let index;
        if ((index = this.selectedADS.indexOf(selectedPart)) > -1)
          this.selectedADS.splice(index, 1);
        else this.selectedADS.push(selectedPart);
      });
    });
  },
  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
